module.exports = __webpack_public_path__ + "img/rullet_hsgeoje.01ed6436.png";